import React, { FunctionComponent } from 'react';
import { View } from 'react-native';
import { Svg, Path } from 'react-native-svg';

import { Color } from '~/components/color';

import { IconProps } from './icon-types';

export const LogoutIcon: FunctionComponent<IconProps> = ({ fill, size = 24 }) => {
    return (
        <View style={{ width: size, height: size }}>
            {/* @ts-ignore see https://github.com/react-native-svg/react-native-svg/issues/1471 */}
            <Svg accessible={false} viewBox="0 0 24 24" focusable={false} tabIndex="-1">
                <Path
                    d="M9 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H9"
                    fill={Color.TRANSPARENT}
                    stroke={fill ?? Color.ALMOST_BLACK}
                    strokeWidth="2"
                />
                <Path
                    d="M16 8L20 12L16 16"
                    fill={Color.TRANSPARENT}
                    stroke={fill ?? Color.ALMOST_BLACK}
                    strokeWidth="2"
                />
                <Path d="M20 12H9" stroke={fill ?? Color.ALMOST_BLACK} strokeWidth="2" />
            </Svg>
        </View>
    );
};
